import React from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Search } from "lucide-react";
import { usePlatformAuth } from "@/contexts/PlatformAuthContext";

const SHOW_ON = (p) => p.startsWith("/watch") || p.startsWith("/videos/") || p.startsWith("/u/") || p === "/profile";

// Mobile-only search next to the notification bell, on the video feed, single video
// and profile pages (other platform pages have their own search).
export const TopSearchButton = () => {
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const { isSubscriber } = usePlatformAuth();
  if (!SHOW_ON(pathname)) return null;
  return (
    <button
      onClick={() => window.dispatchEvent(new Event("open-global-search"))}
      data-testid="top-search"
      aria-label={t("nav.search")}
      title={t("nav.search")}
      className="hide-in-video-fs md:hidden fixed top-4 z-[80] w-11 h-11 rounded-full flex items-center justify-center"
      style={{ right: isSubscriber ? 68 : 16, background: "var(--bg-surface)", border: "1px solid var(--border-color)", boxShadow: "0 2px 10px rgba(0,0,0,0.08)" }}
    >
      <Search size={20} style={{ color: "var(--text-primary)" }} />
    </button>
  );
};

export default TopSearchButton;
